import React, { ComponentClass, PureComponent, ReactNode } from "react";
import { Mutation, MutationResult } from "react-apollo";

import UserRecoverPasswordMutation from "./graphql/UserRecoverPassword";

export interface IUserRecoverPasswordProps {
  recoveringPassword: boolean;
  userRecoverPassword: (email: string) => Promise<MutationResult<boolean>>;
}

export default <P extends object>(
  Component: React.ComponentType<P>
): ComponentClass<P> =>
  class UserRecoverPassword extends PureComponent<P> {
    public render(): ReactNode {
      return (
        <Mutation mutation={UserRecoverPasswordMutation}>
          {(
            userRecoverPassword: (params: {
              variables: {
                email: string;
              };
            }) => void,
            { loading }: { loading: boolean }
          ): JSX.Element => {
            return (
              <Component
                {...this.props}
                recoveringPassword={loading}
                userRecoverPassword={(email: string): void =>
                  userRecoverPassword({
                    variables: { email },
                  })
                }
              />
            );
          }}
        </Mutation>
      );
    }
  };
